import { Component, input } from '@angular/core';
import { TooltipDirective, TooltipPosition } from '../../../../core/directives/tooltip';
import { NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-user-photo-initials',
  imports: [NgOptimizedImage, TranslateModule, TooltipDirective],
  templateUrl: './user-photo-initials.component.html',
  styleUrl: './user-photo-initials.component.scss',
  standalone: true,
})
export class UserPhotoInitialsComponent {
  picture = input<string>('');
  fullName = input<string>('');
  tooltipText = input<string>('');

  protected readonly TooltipPosition = TooltipPosition;

  protected getInitials(): string {
    const fullName = this.fullName?.().trim();
    if (!fullName) return '';

    const parts = fullName.split(/\s+/);
    const surnameInitial = parts[0]?.[0] ?? '';
    const nameInitial = parts[1]?.[0] ?? '';

    return (surnameInitial + nameInitial).toUpperCase();
  }
}
